///* eslint-disable */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import InputMask from 'react-input-mask';
import validator from 'validator';
import { generatePath } from 'react-router-dom';
import {
    Divider,
    Box,
    Typography,
    // Checkbox,
    Button,
    Grid,
    AppBar,
    Stack,
    // FormControl,
    TextField,
    // RadioGroup,
    // FormControlLabel,
    // Radio,
    // FormGroup,
    // Tooltip,
    // IconButton,
    Autocomplete,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormControl,
    FormHelperText,
    CircularProgress,
    Backdrop
} from '@mui/material';
import { createState, useState, Downgraded } from '@hookstate/core';
import { updateModuleState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
import AppConstants from '../../constants/appConstants';
import Title from '../../sharedcomponents/title/title';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import {
    useAgentSaveAsDraftState, setAgentShowConfirmPopUp, resetSaveAsDraftState
} from '../../hookState/AgentSaveAsDraftState';
import { useEventState } from "../../stores/eventStore";
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import { RouterPrompt } from '../../router/routerPrompt';
import { changeAgentUserHandler } from '../../utility/agentChangeUtility';

const appBarStyle = {
    mb: 1,
    boxShadow: 'none',
    pt: 1,
    pb: 1,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
};

const eventState = createState({
    firstName: '',
    lastName: '',
    email: '',
    contactNo: '1',
    alternateContactName: '',
    alternateContactNo: '',
    alternateContactEmail: '',
    hotel: null,
    chair: null,
    hotelName: "",
    ringSize: [],
    registrationID: 0,
    addedFor: 0,
    comments: '',
    accommodation: '',
});
const ringSizes = [
    { label: '1' }, { label: '1.5' }, { label: '2' }, { label: '2.5' }, { label: '3' }, { label: '3.5' }
    , { label: '4' }, { label: '4.5' }, { label: '5' }, { label: '5.5' }, { label: '6' }, { label: '6.5' }
    , { label: '7' }, { label: '7.5' }, { label: '8' }, { label: '8.5' }, { label: '9' }, { label: '9.5' }
    , { label: '10' }, { label: '1o.5' }, { label: '11' }, { label: '11.5' }, { label: '12' }, { label: '12.5' }, { label: '13' }, { label: '13.5' }
    , { label: '14' }, { label: '14.5' }, { label: '15' }, { label: '15.5' }, { label: '16' }, { label: '16.5' }
    , { label: '17' }, { label: '17.5' }, { label: '18' }, { label: '18.5' }, { label: '19' }, { label: '19.5' }
    , { label: '20' }]
const AllStarRegistration = (props) => {

    const state = useState(eventState);
    const agentSaveAsDraftState = useAgentSaveAsDraftState();
    const selectedRing = useState([]);
    // const agentState = useAgentState();
    // const agentInfo = Helper.getStorage('agentInfo');
    const userInfo = Helper.getStorage('userInfo');
    const reventState = useEventState();
    // const moduleIndex = useState(-1);
    const [emailErr, setEmailErr] = React.useState('');
    const [altEmailErr, setAltEmailErr] = React.useState('');
    const [phoneError, setPhoneError] = React.useState('');
    // const [altPhoneError, setAltPhoneError] = React.useState('');
    const [firstNameErr, setFirstNameErr] = React.useState('');
    const [altNameErr, setAltNameErr] = React.useState('');
    const [chairErr, setChairErr] = React.useState('');
    const [hotelLErr, setHotelLErr] = React.useState('');
    // const [hotelErr, setHotelErr] = React.useState('');
    // const [autoApprove, setAutoApprove] = React.useState(0);
    const [locationErr, setLocationErr] = React.useState('');
    const [ringErr, setRingErr] = React.useState('');
    const [accomodationErr, setAccomodationErr] = React.useState('');
    const [checkEditPermission, setCheckEditPermission] = React.useState(false);
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [disableDraftBtn, setDisableDraftBtn] = React.useState(true);
    const [participant, setParticipant] = React.useState(null);
    const [showRingSize, setShowRingSize] = React.useState(false);
    const [showDetails, setShowDetails] = React.useState(false);
    const [showDetailData, setShowDetailData] = React.useState('');
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [saveAsDraftLoader, setSaveAsDraftLoader] = React.useState(false);
    const [dirty, setDirty] = React.useState(false);
    const [openBackdrop, setOpenBackDrop] = React.useState(false);
    const regex = new RegExp('[^\\s]+')
    const eventInfo = Helper.getStorage('eventInfo');
    let params = useParams();

    useEffect(() => {
        resetState(true);
        resetSaveAsDraftState();
        // const eventInfo = Helper.getStorage('eventInfo');
        // ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false))
        //     .then((res) =>
        //     {
        //         if (res.data)
        //         {
        //             res.data.map((auto) =>
        //             {
        //                 if (auto.moduleName === "AllStarRegistration")
        //                 {
        //                     setAutoApprove(auto.autoApprove)
        //                 }
        //             })
        //         }
        //     })
        return () => {
            resetSaveAsDraftState();
        }
    }, [])

    useEffect(() => {
        if (reventState.eventDetail.get() !== null) {
            const index = reventState.eventDetail
                .get()
                .moduleDetails?.findIndex((element) => {
                    if (element.moduleName === 'AllStarRegistration') {
                        return true;
                    }
                });
            const userInfo = Helper.getStorage('userInfo');

            // if (!Helper.isAdminUser(userInfo)) {
                if (
                    reventState.eventDetail.get() &&
                    ((index > 0 &&
                        reventState.eventDetail.get().moduleDetails[index]
                            ?.details !== null) ||
                        reventState.eventDetail.get().moduleDetails[index]
                            ?.details !== '')
                ) {
                    setShowDetails(true);
                    setShowDetailData(
                        reventState.eventDetail.get().moduleDetails[index]
                            ?.details
                    );
                } else {
                    setShowDetails(false);
                    setShowDetailData('');
                }
            // }
        }
    }, [reventState])
    useEffect(() => {
        if (props.modPermission) {
            if (props.modPermission == FULL_PERMISSION) {
                setCheckEditPermission(true);
            }
            else if (props.modPermission == VIEW_PERMISSION) {
                setCheckEditPermission(false);
            }
            else {
                setCheckEditPermission(false);
            }
        }
    }, [props]);
    let rows = []
    for (let i = 1; i <= 20; i += 0.5) {
        rows.push(i)
    }
    useEffect(() => {
        if (!Helper.isAdminUser(userInfo) && !Helper.isEventStaff(userInfo)) {
            const eventInfo = Helper.getStorage('eventInfo');
            if (userInfo && userInfo.tags && userInfo.tags.length > 0) {
                userInfo.tags.map((vals) => {
                    if (vals.eventID === eventInfo.eventID) {
                        if (String(vals.userTags) !== "null") {
                            ApiHelper.get(
                                APIURLConstants.GET_EVENT_CONFIG(0)
                            ).then((res) => {
                                if (res.data) {
                                    res.data.map((val) => {
                                        if (val.moduleID === 18) {
                                            const splitTags = vals.userTags.split(',');
                                            let showFalseObj = [];

                                            splitTags.map((vals) => {
                                                const match = val.description.trim().match(vals.trim());
                                                if (match !== null) {
                                                    showFalseObj.push(vals)
                                                    setShowRingSize(true);
                                                    return;
                                                }
                                                //  else {
                                                //     setShowRingSize(false);
                                                // }
                                            })
                                            if (showFalseObj.length === 0) {
                                                setShowRingSize(false);
                                            }
                                        }
                                    })
                                }
                            })
                        }
                    } else {
                        setShowRingSize(false);
                    }
                })
            }
        }
    }, [])

    useEffect(() => {
        if (props.showSaveAsDraftBtn) {
            setDirty(agentSaveAsDraftState.showConfirmPopUp.get());
        }
        else {
            setDirty(false);
        }

    }, [agentSaveAsDraftState, props.showSaveAsDraftBtn])

    useEffect(() => {
        async function updateOnProps() {
            if (props.asAdmin) {
                resetState(true);
            }
            if (props.data) {
                const userData = props.data;
                state.firstName.set(userData.firstName);
                state.lastName.set(userData.lastName);
                state.email.set(userData.email);
                state.contactNo.set(userData.contactNo ? userData.contactNo : '1');
                state.hotel.set(userData.isHotelCheck != null ? (userData.isHotelCheck === true ? 'Yes' : 'No') : null);
                state.chair.set(userData.isWheelCheck != null ? (userData.isWheelCheck === true ? 'Yes' : 'No') : null);
                state.alternateContactName.set(userData.alternateContactName ? userData.alternateContactName : '');
                state.alternateContactNo.set(userData.alternateContactNo ? userData.alternateContactNo : '');
                state.alternateContactEmail.set(userData.alternateContactEmail ? userData.alternateContactEmail : '');
                state.ringSize.set(userData.ringSize ? `${userData.ringSize}` : '');
                selectedRing.set(userData.ringSize ? { label: `${userData.ringSize}` } : []);
                state.hotelName.set(userData.location !== '' ? userData.location : '')
                state.comments.set(userData.comments !== '' ? userData.comments : '')
                state.registrationID.set(
                    userData.registrationID ? userData.registrationID : 0
                );
                state.addedFor.set(userData.addedFor);
                state.accommodation.set(userData.occommodation);
                const index = props.participantList && props.participantList.findIndex(
                    (user) => user.userID == userData.addedFor
                );
                if (parseInt(props.data.requestStatus) !== 0) {
                    setDisableBtn(true)
                }
                else {
                    setDisableBtn(false)
                }
                if (index != null && index > -1) {
                    setParticipant(props.participantList[index]);
                    if (String(props.participantList[index].userTags) !== "null") {
                        ApiHelper.get(
                            APIURLConstants.GET_EVENT_CONFIG(0)
                        ).then((res) => {
                            if (res.data) {
                                res.data.map((val) => {
                                    if (val.moduleID === 18) {
                                        const splitTags = props.participantList[index].userTags.split(',');
                                        let showFalseObj = [];
                                        splitTags.map((vals) => {
                                            const match = val.description.trim().match(vals.trim());
                                            if (match !== null) {
                                                showFalseObj.push(vals)
                                                setShowRingSize(true);
                                                return;
                                            }
                                        })
                                        if (showFalseObj.length === 0) {
                                            setShowRingSize(false);
                                        }
                                    }
                                })
                            }
                        })
                    } else {
                        setShowRingSize(false);
                    }
                } else {
                    const eventInfo = Helper.getStorage('eventInfo');
                    if (userInfo.tags && userInfo.tags.length > 0) {
                        userInfo.tags.map((vals) => {
                            if (vals.eventID === eventInfo.eventID) {
                                if (String(vals.userTags) !== "null") {
                                    ApiHelper.get(
                                        APIURLConstants.GET_EVENT_CONFIG(0)
                                    ).then((res) => {
                                        if (res.data) {
                                            res.data.map((val) => {
                                                if (val.moduleID === 18) {
                                                    const splitTags = vals.userTags.split(',');
                                                    let showFalseObj = [];

                                                    splitTags.map((vals) => {
                                                        const match = val.description.trim().match(vals.trim());
                                                        if (match !== null) {
                                                            showFalseObj.push(vals)
                                                            setShowRingSize(true);
                                                            return;
                                                        }
                                                        //  else {
                                                        //     setShowRingSize(false);
                                                        // }
                                                    })
                                                    if (showFalseObj.length === 0) {
                                                        setShowRingSize(false);
                                                    }
                                                }
                                            })
                                        }
                                    })
                                }
                            } else {
                                setShowRingSize(false);
                            }
                        })
                    }
                    if (userInfo.userTags && String(userInfo.userTags) !== "null") {
                        ApiHelper.get(
                            APIURLConstants.GET_EVENT_CONFIG(0)
                        ).then((res) => {
                            if (res.data) {
                                res.data.map((val) => {
                                    if (val.moduleID === 18) {
                                        const splitTags = userInfo.userTags.split(',');
                                        let showFalseObj = [];
                                        splitTags.map((vals) => {
                                            const match = val.description.trim().match(vals.trim());
                                            if (match !== null) {
                                                showFalseObj.push(vals)
                                                setShowRingSize(true);
                                                return;
                                            }
                                            //  else {
                                            //     setShowRingSize(false);
                                            // }
                                        })
                                        if (showFalseObj.length === 0) {
                                            setShowRingSize(false);
                                        }
                                    }
                                })
                            }
                        })
                    } else {
                        setShowRingSize(false);
                    }
                }

            } else {
                setDisableBtn(false);
                if (userInfo.userTags && String(userInfo.userTags) !== "null") {
                    ApiHelper.get(
                        APIURLConstants.GET_EVENT_CONFIG(0)
                    ).then((res) => {
                        if (res.data) {
                            res.data.map((val) => {
                                if (val.moduleID === 18) {
                                    const splitTags = userInfo.userTags.split(',');
                                    let showFalseObj = [];
                                    splitTags.map((vals) => {
                                        const match = val.description.trim().match(vals.trim());
                                        if (match !== null) {
                                            showFalseObj.push(vals)
                                            setShowRingSize(true);
                                            return;
                                        }
                                        //  else {
                                        //     setShowRingSize(false);
                                        // }
                                    })
                                    if (showFalseObj.length === 0) {
                                        setShowRingSize(false);
                                    }
                                }
                            })
                        }
                    })
                }
            }
        }
        updateOnProps();
    }, [props.data]);
    const resetState = (flag) => {
        setFirstNameErr('');
        // setLastNameErr('');
        setPhoneError('');
        setEmailErr('');
        setAltNameErr('')
        setAltEmailErr('');
        // setAltPhoneError('');

        state.set({
            // firstName: agentState.visible.value ? userInfo.firstName : '',
            // lastName: agentState.visible.value ? userInfo.lastName : '',
            // email: agentState.visible.value ? userInfo.email : '',
            firstName: '',
            lastName: '',
            email: '',
            dob: null,
            chair: null,
            hotel: null,
            contactNo: '1',
            alternateContactName: '',
            alternateContactNo: '',
            alternateContactEmail: '',
            comments: '',
            ringSize: '',
            registrationID: flag ? 0 : state.registrationID.get(),
            addedFor: flag ? 0 : state.addedFor.get(),
        });
    };

    const handleClick = (event) => {
        event.preventDefault();
        resetSaveAsDraftState();
        setDisableBtn(true);
        setDisableDraftBtn(true);
        setCheckEditPermission(false)
        const selectedState = state.get();
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        const setUserTags = selectedRing.attach(Downgraded).get();
        if (!isValidForm()) {
            setDisableBtn(false);
            setDisableDraftBtn(false);
            setCheckEditPermission(true)
            return false;
        } else {
            props.loading.set(true)
            setDisableBtn(true);
            setDisableDraftBtn(true);
            setCheckEditPermission(false)
            let Obj = {
                registrationID: selectedState.registrationID,
                eventID: eventInfo.eventID,
                firstName: selectedState.firstName,
                lastName: selectedState.lastName,
                contactNo: selectedState.contactNo,
                email: selectedState.email,
                alternateContactName: selectedState.alternateContactName,
                alternateContactNo: selectedState.alternateContactNo,
                alternateContactEmail: selectedState.alternateContactEmail,
                isWheelCheck: selectedState.chair === 'Yes' ? true : false,
                isHotelCheck: selectedState.hotel === 'Yes' ? true : false,
                ringSize: setUserTags.label,
                occommodation: selectedState.accommodation,
                location: selectedState.hotelName,
                addedFor: (Helper.isEventAdmin(gAgentInfo) || Helper.isAdminUser(gAgentInfo)) ? participant
                    && participant.userID : agentConnection && gAgentInfo ? gAgentInfo.userID : participant ? participant.userID : selectedState.addedFor ? selectedState.addedFor : userInfo.userID,
                createdBy: userInfo.userID,
                comments: selectedState.comments,
            };

            ApiHelper.get(APIURLConstants.CHECK_MODULE_DATA_EXIST_FOR_USER(18, eventInfo.eventID, Obj.addedFor, Obj.registrationID))
                .then((result) => {
                    if (!result.data) {
                        ApiHelper.post(APIURLConstants.POST_ALLSTAR_REGISTRATION_INFO, Obj)
                            .then(async (res) => {
                                if (res.status === 200) {
                                    setSnackBarProps({
                                        ...snackBarProps,
                                        openSnack: true,
                                        variant: 'success',
                                        message: state.addedFor.get() > 0 && !props.showSaveAsDraftBtn
                                            ? 'Form updated successfully' : 'Form submitted successfully',
                                    });
                                    props.loading.set(false)
                                    setTimeout(() => {
                                        // console.log("gAgentInfo",gAgentInfo);
                                        setDisableBtn(true)
                                        if (gAgentInfo) {
                                            if (Helper.isAdminUser(gAgentInfo) ||
                                                (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo))) {
                                                // console.log("into agent admin user");
                                                props.history.push(generatePath(RouteConstants.EVENT_ALLSTAR_REGISTRATION_LIST, {
                                                    eventID: eventInfo.eventID,
                                                }))
                                            } else {
                                                // console.log("into else agent admin user");
                                                props.history.push(generatePath(RouteConstants.EVENT_DETAIL, {
                                                    eventID: eventInfo.eventID,
                                                }))
                                                props.getAllRegistrationInfo()
                                                updateModuleState()
                                            }
                                        } else if (Helper.isAdminUser(userInfo) ||
                                            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))) {
                                            // console.log("into admin user");
                                            props.history.push(generatePath(RouteConstants.EVENT_ALLSTAR_REGISTRATION_LIST, {
                                                eventID: eventInfo.eventID,
                                            }))
                                        } else {
                                            props.history.push(generatePath(RouteConstants.EVENT_DETAIL, {
                                                eventID: eventInfo.eventID,
                                            }))
                                            props.getAllRegistrationInfo()
                                            updateModuleState()
                                        }
                                    }, 1000);
                                    // if (autoApprove === 1 || state.addedFor.get() > 0) { 
                                    // await SETEmailNotification({ ...Obj });
                                    // }
                                }
                            })
                            .catch((error) => {
                                props.loading.set(false)
                                showErrorSnackBar(error);
                            });
                    }
                    else {
                        props.loading.set(false);
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'warning',
                            message: 'Already registered for this event.',
                        });
                    }

                }).catch(error => {
                    props.loading.set(false)
                    showErrorSnackBar(error);
                });

        }
    };

    const showErrorSnackBar = (error) => {
        let message = '';
        if (error.response && error.response.status === 401) {
            message = 'Access denied';
        } else {
            message = 'Error while Adding Registration';
        }
        setSnackBarProps({
            openSnack: true,
            variant: 'error',
            message: message,
        });
    }

    const checkValidPhone = (val) => {
        state.contactNo.set(val);
        setPhoneError('')
        handleDisableBtn()
        // const phone = state.contactNo.get() ?? "";
        // if (
        //     phone.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)
        // )
        // {
        //     setPhoneError('');
        // } else
        // {
        //     if (phone != "")
        //     {
        //         setPhoneError('Please enter valid phone no');
        //     } else
        //     {
        //         setPhoneError('');
        //     }
        // }
    };
    const checkAltValidPhone = (val) => {
        state.alternateContactNo.set(val);
        // const phone = state.alternateContactNo.get() ?? "";
        // if (
        //     phone.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)
        // )
        // {
        //     setAltPhoneError('');
        // } else
        // {
        //     if (phone != "")
        //     {
        //         setAltPhoneError('Please enter valid phone no');
        //     } else
        //     {
        //         setAltPhoneError('');
        //     }
        // };
        handleDisableBtn()
    }
    // const validateFirstName = () => {
    //     let value = state.firstName.get().trim();
    //     if (validator.isAlpha(value)) {
    //         setFirstNameErr('');
    //         return true;
    //     } else setFirstNameErr('Please Enter Valid Name');
    //     return false;
    // };
    const validateFirstName = () => {
        let value = state.firstName.get().trim();

        if (Helper.onlyLettersAndSpacesWithHyphens(value)) {
            setFirstNameErr('');
            return true;
        } else {
            setFirstNameErr('Please Enter Valid Name');
            return false;
        }
    };

    const validateRingSize = () => {
        if (selectedRing.attach(Downgraded).get() !== null) {
            if (selectedRing.attach(Downgraded).get().label === undefined) {
                setRingErr('Please select ring size')
            } else {
                setRingErr('')
            }
        } else {
            setRingErr('')
        }

    }
    const ValidAccomodation = () => {
        const accommodationValue = state.accommodation.get().trim();
        if (accommodationValue === '') {
            setAccomodationErr('Please select Accommodation')
        } else {
            setAccomodationErr('')
        }
    }
    const validateAltName = () => {
        let value = state.alternateContactName.get().trim();
        if (value === "") {
            setAltNameErr('');
            return true;
        } else if (Helper.onlyLettersAndSpacesWithHyphens(value)) {
            setAltNameErr('');
            return true;
        } else setAltNameErr('Please Enter Valid Alternate Contact Name');
        return false;
    };
    const isValidForm = () => {
        const selectedState = state.get();
        let isValid = true;
        if (selectedState.firstName === null || firstNameErr.length > 0 || selectedState.firstName?.trim()?.length == 0) {
            setFirstNameErr('Please Enter Valid Name')
            isValid = false;
        }
        else if (selectedState.email === null || emailErr.length > 0 || selectedState.email?.trim()?.length == 0) {
            setEmailErr('Please Enter Valid Email')
            isValid = false;
        }
        else if ((selectedState.contactNo === null || selectedState.contactNo === '' || phoneError.length > 0 || selectedState.contactNo == '1')) {
            setPhoneError('Please Enter Valid Contact Number')
            isValid = false;
        }
        else if (altNameErr.length > 0) {
            setAltNameErr('Please Enter Valid Alternate Contact Name')
            isValid = false;
        }
        else if (altEmailErr.length > 0) {
            setAltEmailErr('Please Enter Valid Alternate Email')
            isValid = false;
        }
        else if (selectedState.chair === null || selectedState.chair === "") {
            setChairErr('Please Select Wheelchair')
            isValid = false;
        }
        else if (selectedState.hotel === null || selectedState.hotel === "") {
            setHotelLErr('Please Select NBA Hotel')
            isValid = false;
        }
        else if (selectedState.hotel === "No" && (selectedState.hotelName === null || selectedState.hotelName === '' || selectedState.hotelName === undefined)) {
            setLocationErr('Please Enter location')
            isValid = false;
        }
        else if (selectedState.chair === "Yes" && (selectedState.accommodation === null || selectedState.accommodation === '' || selectedState.accommodation === undefined)) {
            setAccomodationErr('Please Enter Accommodation')
            isValid = false;
        }
        else if (showRingSize) {
            if (selectedRing.attach(Downgraded).get() === null) {
                setRingErr('Please select ring size')
                isValid = false;
            } else
                if (selectedRing.attach(Downgraded).get().label === undefined) {
                    setRingErr('Please select ring size')
                    isValid = false;
                }
        }
        else {
            isValid = true
        }
        return isValid;
    }

    // const validatelastName = () => {
    //     let value = state.lastName.get().trim();
    //     if (validator.isAlpha(value)) {
    //         setLastNameErr('');
    //         return true;
    //     } else {
    //         setLastNameErr('Please Enter Valid Name');
    //         return false;
    //     }
    // };

    function ValidateEmail() {
        const value = state.email.get().trim();
        if (Helper.validEmail(value)) {
            setEmailErr('');
        } else if (value == '') {
            setEmailErr('Please enter Email');
        } else {
            setEmailErr('Please enter valid Email');
        }

    }
    function ValidateAlternateEmail() {
        const value = state.alternateContactEmail.get() ?? "";
        if (Helper.validEmail(value)) {
            setAltEmailErr('');
        }
        else {
            setAltEmailErr('Please enter valid Alternate Email');
        }
    }
    const validateLocation = () => {
        let value = state.hotel.get().trim()
        if (!validator.isAlpha(value)) {
            setLocationErr('Enter valid location')
        }
        else {
            setLocationErr('')
        }
    }
    const handleCancelReq = () => {
        resetState(true);
        props.handleCancel();
    };

    const changeParticipant = async (participant) => {
        setParticipant(participant);

        if (participant) {
            state.alternateContactName.set('')
            state.alternateContactNo.set('');
            state.alternateContactEmail.set('')
            state.comments.set('')
            setFirstNameErr('');
            setPhoneError('');
            setEmailErr('');
            setAltNameErr('')
            setAltEmailErr('');
            // setAltPhoneError('');
            if (String(participant.userTags) !== "null") {
                ApiHelper.get(
                    APIURLConstants.GET_EVENT_CONFIG(0)
                ).then((res) => {
                    if (res.data) {
                        res.data.map((val) => {
                            if (val.moduleID === 18) {
                                const splitTags = participant.userTags.split(',');
                                let showFalseObj = [];
                                splitTags.map((vals) => {
                                    const match = val.description.trim().match(vals.trim());
                                    if (match !== null) {
                                        showFalseObj.push(vals)
                                        setShowRingSize(true);
                                        return;
                                    }
                                })
                                if (showFalseObj.length === 0) {
                                    setShowRingSize(false);
                                }
                            }
                        })
                    }
                })
            } else {
                setShowRingSize(false);
            }

        } else {
            resetState(false);
        }
    };

    // const SETEmailNotification = (ObjRequest) =>
    // {
    //     return ApiHelper.post(
    //         APIURLConstants.POST_SET_ALLSTAR_REGISTRATION_EMAIL_NOTIFICATION,
    //         ObjRequest
    //     )
    //         .then((result) =>
    //         {
    //             return result.data;
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };

    const handleHotelChange = (e) => {
        state.hotel.set(e.target.value)
        setHotelLErr('');
        handleDisableBtn()
    }
    const handleChairChange = (e) => {
        state.chair.set(e.target.value)
        setChairErr('')
        handleDisableBtn()
        state.accommodation.get() === '' ? state.accommodation.set('') : null
    }
    const handleDisableBtn = () => {
        if (props.data) {
            let registerData = props.data
            let prevData = {
                firstName: registerData.firstName ? registerData.firstName : '',
                lastName: registerData.lastName ? registerData.lastName : '',
                email: registerData.email ? registerData.email : '',
                contactNo: registerData.contactNo ? registerData.contactNo : '',
                isWheelCheck: registerData.isWheelCheck !== null ? registerData.isWheelCheck : null,
                isHotelCheck: registerData.isHotelCheck !== null ? registerData.isHotelCheck : null,
                hotelName: registerData.location ? registerData.location : '',
                alternateContactName: registerData.alternateContactName ? registerData.alternateContactName : null,
                alternateContactNo: registerData.alternateContactNo ? registerData.alternateContactNo : null,
                alternateContactEmail: registerData.alternateContactEmail ? registerData.alternateContactEmail : null,
                comments: registerData.comments ? registerData.comments : null,
                ringSize: registerData.ringSize ? registerData.ringSize : null,
                accommodation: registerData.accommodation ? registerData.accommodation : null,
            }
            let currentData = {
                firstName: state.get().firstName,
                lastName: state.get().lastName,
                email: state.get().email,
                contactNo: state.get().contactNo,
                isWheelCheck: state.get().chair ? (state.get().chair === 'Yes' ? true : false) : null,
                isHotelCheck: state.get().hotel ? (state.get().hotel === 'Yes' ? true : false) : null,
                hotelName: state.get().hotelName ? state.get().hotelName : '',
                alternateContactName: state.get().alternateContactName ? state.get().alternateContactName : null,
                alternateContactNo: state.get().alternateContactNo ? state.get().alternateContactNo : null,
                alternateContactEmail: state.get().alternateContactEmail ? state.get().alternateContactEmail : null,
                comments: state.get().comments ? state.get().comments : null,
                ringSize: selectedRing.get() !== null && selectedRing.get().label ? selectedRing.get().label : null,
                accommodation: state.get().accommodation ? state.get().accommodation : null
            }
            //console.log('handleDisable', prevData, currentData)
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setAgentShowConfirmPopUp(false);
                if (registerData.requestStatus && parseInt(registerData.requestStatus) !== 0) {
                    setDisableBtn(true);
                }
                setDisableDraftBtn(true);
            } else {
                if (props.showSaveAsDraftBtn) {
                    setAgentShowConfirmPopUp(true);
                }
                setDisableBtn(false);
                setDisableDraftBtn(false);
            }
        }
        else {
            if (props.showSaveAsDraftBtn) {
                setAgentShowConfirmPopUp(true);
            }
            setDisableBtn(false);
            setDisableDraftBtn(false);
        }
    }

    const handleSaveAsDraft = async (event) => {
        let Obj = generatePostObjForSaveAsDraft();
        setSaveAsDraftLoader(true);
        setDisableDraftBtn(true);
        setDisableBtn(true);
        ApiHelper.post(APIURLConstants.POST_ALLSTAR_REGISTRATION_INFO, Obj)
            .then(async (res) => {
                setSaveAsDraftLoader(false);
                setAgentShowConfirmPopUp(false);
                setDisableBtn(false);
                if (res.status === 200) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Form saved successfully',
                    });
                    props.getAllRegistrationInfo();
                    updateModuleState();
                }
            })
            .catch((error) => {
                setSaveAsDraftLoader(false);
                showErrorSnackBar(error);
            });
    }

    const handleSaveAsDraftOnPromptConfirm = () => {
        return new Promise((resolve, reject) => {
            let Obj = generatePostObjForSaveAsDraft();
            setOpenBackDrop(true);
            setDisableBtn(true);
            ApiHelper.post(APIURLConstants.POST_ALLSTAR_REGISTRATION_INFO, Obj)
                .then((res) => {
                    setOpenBackDrop(false);
                    if (res.status === 200) {
                        //below code is added to check to show save as draft pop up in case of agent dropdown
                        if (agentSaveAsDraftState.showConfirmPopUp.get() && agentSaveAsDraftState.agentUserInfo.get()) {
                            changeAgentUserHandler(agentSaveAsDraftState.agentUserInfo.get(), agentSaveAsDraftState.userEvents.get());
                        }
                        else {
                            props.getAllRegistrationInfo();
                            updateModuleState();
                            resetSaveAsDraftState();
                        }
                        resolve(true);
                    }
                })
                .catch((error) => {
                    setOpenBackDrop(false);
                    showErrorSnackBar(error);
                    resetSaveAsDraftState();
                    reject(false);
                });
        })
    }

    const generatePostObjForSaveAsDraft = () => {
        const selectedState = state.get();
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        const setUserTags = selectedRing.attach(Downgraded).get();
        let Obj = {};
        Obj = {
            registrationID: selectedState.registrationID,
            eventID: eventInfo.eventID,
            firstName: selectedState.firstName ? selectedState.firstName : '',
            lastName: selectedState.lastName ? selectedState.lastName : '',
            contactNo: selectedState.contactNo ? selectedState.contactNo : '',
            email: selectedState.email ? selectedState.email : '',
            alternateContactName: selectedState.alternateContactName ? selectedState.alternateContactName : '',
            alternateContactNo: selectedState.alternateContactNo ? selectedState.alternateContactNo : '',
            alternateContactEmail: selectedState.alternateContactEmail ? selectedState.alternateContactEmail : '',
            isWheelCheck: selectedState.chair ? (selectedState.chair === 'Yes' ? true : false) : null,
            isHotelCheck: selectedState.hotel ? (selectedState.hotel === 'Yes' ? true : false) : null,
            ringSize: setUserTags.label ? setUserTags.label : null,
            occommodation: selectedState.accommodation ? selectedState.accommodation : '',
            location: selectedState.hotelName ? selectedState.hotelName : '',
            addedFor: (Helper.isEventAdmin(gAgentInfo) || Helper.isAdminUser(gAgentInfo)) ? participant
                && participant.userID : agentConnection && gAgentInfo ? gAgentInfo.userID : participant ? participant.userID : selectedState.addedFor ? selectedState.addedFor : userInfo.userID,
            createdBy: userInfo.userID,
            comments: selectedState.comments,
            isDraft: true
        };

        return Obj;
    }

    const handleCancelConfirmation = () => {
        //below code is added to check to show save as draft pop up in case of agent dropdown
        if (agentSaveAsDraftState.showConfirmPopUp.get() && agentSaveAsDraftState.agentUserInfo.get()) {
            changeAgentUserHandler(agentSaveAsDraftState.agentUserInfo.get(), agentSaveAsDraftState.userEvents.get());
        }

        return true;
    }

    return (
        <Box>
            <Box sx={{ ml: 2, mt: 2 }}>
                <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                    AppConstants.EVENT_MODULES.ALL_STAR_REGISTRATION)}
                    header={true} />
                {showDetails ? (
                    <DetailsComponent data={showDetailData} />
                ) : null}
            </Box>
            <Box className="contentBox">
                <Box component="div">
                    <Box sx={{ width: '100%' }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item container>
                                <>
                                    <Grid item md={4}></Grid>
                                    <Grid item xs={12} md={4}>
                                        <ParticipantAutoList
                                            disableParticipant={
                                                props.data && props.data
                                                    ? true
                                                    : false
                                            }
                                            participant={participant}
                                            setParticipant={changeParticipant}
                                            participantList={
                                                props.participantList
                                            }
                                            modPermission={props.modPermission}
                                        />
                                    </Grid>
                                    <Grid item md={4}></Grid>
                                    <Grid item md={12} sx={{ mt: 2 }}>
                                        <AppBar
                                            position="static"
                                            color="default"
                                            sx={appBarStyle}>
                                            <Typography
                                                variant="h4"
                                                flexGrow={1}
                                                fontSize={15}
                                                fontWeight={700}
                                                fontFamily={'Lato'}
                                                noWrap
                                                fontStyle="normal"
                                                color='primary'
                                                component="div"
                                                sx={{
                                                    ml: 1,
                                                }}
                                            >
                                                Point of contact
                                            </Typography>
                                            {/* <Title
                                                title={'Point of contact'}
                                                sx={{
                                                    ml: 1,
                                                }}
                                            /> */}
                                        </AppBar>
                                    </Grid>
                                </>
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    size="small"
                                    label="Name"
                                    required
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.firstName.get()}
                                    // onBlur={() =>
                                    //     params.userID > 0
                                    //         ? null
                                    //         : validateFirstName()
                                    // }
                                    onChange={(event) => {
                                        regex.test(event.target.value)
                                            ? state.firstName.set(
                                                event.target.value
                                            )
                                            : state.firstName.set(
                                                event.target.value.trim()
                                            );
                                        validateFirstName();
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        firstNameErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        firstNameErr.length > 0
                                            ? firstNameErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    error={emailErr.length > 0 ? true : false}
                                    required
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Email"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.email.set(email);
                                        handleDisableBtn();
                                        ValidateEmail();
                                    }}
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                    inputProps={{ maxLength: 250 }}
                                    helperText={emailErr}
                                    value={state.email.get()}
                                    onBlur={ValidateEmail}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                {/* <InputMask
                                mask="(999) 999-9999"
                                value={state.contactNo.get()}
                                defaultValue={state.contactNo.get()}
                                disabled={!checkEditPermission}
                                onChange={(e) =>
                                {
                                    const ph = e.target.value;
                                    state.contactNo.set(ph);
                                    handleDisableBtn()
                                    checkValidPhone()
                                }}
                                onBlur={checkValidPhone}>
                                {() => (
                                    <TextField
                                        size="small"
                                        fullWidth
                                        required
                                        disabled={!checkEditPermission}
                                        label="Contact No"
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={state.contactNo.get()}
                                        error={
                                            phoneError.length > 0 ? true : false
                                        }
                                        helperText={
                                            phoneError.length > 0
                                                ? phoneError
                                                : ''
                                        }
                                    />
                                )}
                            </InputMask> */}
                                <PhoneNumber
                                    name={'allStarRegistrationContact'}
                                    placeholder="Contact No"
                                    value={state.contactNo.get()}
                                    onChange={checkValidPhone}
                                    required={true}
                                    helperText={phoneError}
                                    error={phoneError.length > 0 ? true : false}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider
                        light={false}
                        sx={{ mt: 2, marginRight: 0, mb: 2 }}
                        flexItem
                    />

                    <Box component="div" sx={{ width: '100%' }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={12} md={12} xs={12}>
                                <AppBar
                                    position="static"
                                    color="default"
                                    sx={appBarStyle}>
                                    <Typography
                                        variant="h4"
                                        flexGrow={1}
                                        fontSize={15}
                                        fontWeight={700}
                                        fontFamily={'Lato'}
                                        noWrap
                                        fontStyle="normal"
                                        color='primary'
                                        component="div"
                                        sx={{
                                            ml: 0,
                                        }}
                                    >
                                        Alternative point of contact
                                    </Typography>
                                    {/* <Title
                                        title={'Alternative point of contact'}
                                        sx={{
                                            ml: 1,
                                        }}
                                    /> */}
                                </AppBar>
                            </Grid>
                            {/* <Grid item lg={12} md={12} xs={12}>
                            <Typography fontWeight={600}>
                                Alternate Contact (please list family member, agent or coach)
                            </Typography>
                        </Grid> */}
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Alternate Contact Name  "
                                    inputProps={{ maxLength: 200 }}
                                    disabled={!checkEditPermission}
                                    value={state.alternateContactName.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateAltName()
                                    }
                                    error={altNameErr.length > 0 ? true : false}
                                    helperText={
                                        altNameErr.length > 0 ? altNameErr : ''
                                    }
                                    onChange={(event) => {
                                        regex.test(event.target.value)
                                            ? state.alternateContactName.set(
                                                event.target.value
                                            )
                                            : state.alternateContactName.set(
                                                event.target.value.trim()
                                            );
                                        handleDisableBtn();
                                        validateAltName();
                                    }}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                {/* <InputMask
                                mask="(999) 999-9999"
                                value={state.alternateContactNo.get()}
                                defaultValue={state.alternateContactNo.get()}
                                disabled={!checkEditPermission}
                                onChange={(e) =>
                                {
                                    const ph = e.target.value;
                                    state.alternateContactNo.set(ph);
                                    handleDisableBtn()
                                    checkAltValidPhone()
                                }}
                                onBlur={checkAltValidPhone}
                            >
                                {() => (
                                    <TextField
                                        size="small"
                                        fullWidth
                                        disabled={!checkEditPermission}
                                        label="Alternate Contact No"
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={state.alternateContactNo.get()}
                                        error={
                                            altPhoneError.length > 0 ? true : false
                                        }
                                        helperText={
                                            altPhoneError.length > 0
                                                ? altPhoneError
                                                : ''
                                        }
                                    />
                                )}
                            </InputMask> */}
                                <TextField
                                    error={
                                        altEmailErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        altEmailErr.length > 0
                                            ? altEmailErr
                                            : ''
                                    }
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.alternateContactEmail.set(email);
                                        handleDisableBtn();
                                        ValidateAlternateEmail();
                                    }}
                                    disabled={!checkEditPermission}
                                    label="Alternate Contact Email"
                                    inputProps={{ maxLength: 255 }}
                                    value={state.alternateContactEmail.get()}
                                    onBlur={ValidateAlternateEmail}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <PhoneNumber
                                    name={'allStarRegistrationAlternetContact'}
                                    placeholder="Alternate Contact No"
                                    value={state.alternateContactNo.get()}
                                    onChange={checkAltValidPhone}
                                    required={false}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}>
                                    <Typography variant="subtitle2">
                                        Do any of your guests need special
                                        accommodations?
                                    </Typography>
                                    <FormControl
                                        error={
                                            chairErr.length > 0 ? true : false
                                        }
                                        variant="standard">
                                        <RadioGroup
                                            row
                                            sx={{ ml: 1 }}
                                            onChange={(e) =>
                                                handleChairChange(e)
                                            }
                                            value={
                                                state.chair.get() ? 'Yes' : 'No'
                                            }>
                                            <FormControlLabel
                                                value="Yes"
                                                control={
                                                    <Radio
                                                        checked={
                                                            state.chair.get() ===
                                                            'Yes'
                                                        }
                                                    />
                                                }
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="No"
                                                control={
                                                    <Radio
                                                        checked={
                                                            state.chair.get() ===
                                                            'No'
                                                        }
                                                    />
                                                }
                                                label="No"
                                            />
                                        </RadioGroup>
                                        <FormHelperText>
                                            {chairErr}
                                        </FormHelperText>
                                    </FormControl>
                                </Box>
                                {state.chair.get() === 'Yes' ? (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                        }}>
                                        <TextField
                                            fullWidth
                                            required
                                            size="small"
                                            id="outlined-basic"
                                            variant="outlined"
                                            label="Accommodation"
                                            inputProps={{ maxLength: 200 }}
                                            value={state.accommodation.get()}
                                            error={
                                                accomodationErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                            helperText={
                                                accomodationErr.length > 0
                                                    ? accomodationErr
                                                    : ''
                                            }
                                            onChange={(event) => {
                                                state.accommodation.set(
                                                    event.target.value
                                                );
                                                ValidAccomodation();
                                                handleDisableBtn();
                                            }}
                                        />
                                    </Box>
                                ) : null}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                    }}>
                                    <Typography variant="subtitle2">
                                        Is the participant staying at the NBA
                                        hotel?
                                    </Typography>
                                    <FormControl
                                        error={
                                            hotelLErr.length > 0 ? true : false
                                        }
                                        variant="standard">
                                        <RadioGroup
                                            row
                                            sx={{ ml: 1 }}
                                            onChange={(e) =>
                                                handleHotelChange(e)
                                            }
                                            value={
                                                state.hotel.get() ? 'Yes' : 'No'
                                            }>
                                            <FormControlLabel
                                                value="Yes"
                                                control={
                                                    <Radio
                                                        checked={
                                                            state.hotel.get() ===
                                                            'Yes'
                                                        }
                                                    />
                                                }
                                                label="Yes"
                                            />
                                            <FormControlLabel
                                                value="No"
                                                control={
                                                    <Radio
                                                        checked={
                                                            state.hotel.get() ===
                                                            'No'
                                                        }
                                                    />
                                                }
                                                label="No"
                                            />
                                        </RadioGroup>
                                        <FormHelperText>
                                            {hotelLErr}
                                        </FormHelperText>
                                    </FormControl>
                                    {/* <Tooltip
                                    title={state.hotel.get() == true ? 'Yes' : 'No'}
                                >
                                    <IconButton
                                        onChange={(e) => handleHotelChange(e)}
                                    >
                                        <IOSYesNoSwitch
                                            sx={{
                                                m: 1,
                                            }}
                                            checked={state.hotel.get()
                                            }
                                        />
                                    </IconButton>
                                </Tooltip> */}
                                </Box>
                                <Typography variant="caption">
                                    <b>Note:</b> If no, please provide the
                                    location where the participant will be
                                    staying.
                                </Typography>
                            </Grid>
                            <Grid item lg={3} md={3} xs={12}>
                                {showRingSize ? (
                                    <Box>
                                        <Autocomplete
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={ringSizes}
                                            // getOptionLabel={(option) => option}
                                            value={selectedRing
                                                .attach(Downgraded)
                                                .get()}
                                            onChange={(e, newValue) => {
                                                selectedRing.set(newValue);
                                                validateRingSize();
                                                handleDisableBtn();
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Ring Size"
                                                    required
                                                    error={
                                                        ringErr.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                    helperText={
                                                        ringErr.length > 0
                                                            ? ringErr
                                                            : ''
                                                    }
                                                />
                                            )}
                                        />
                                    </Box>
                                ) : null}
                            </Grid>
                            <Grid item lg={3} md={3} xs={12}></Grid>
                            {state.hotel.get() === 'No' ? (
                                <Grid item lg={6} md={6} xs={12}>
                                    <TextField
                                        fullWidth
                                        required
                                        size="small"
                                        id="outlined-basic"
                                        variant="outlined"
                                        label="Participant Location"
                                        inputProps={{ maxLength: 200 }}
                                        disabled={!checkEditPermission}
                                        value={state.hotelName.get()}
                                        onBlur={() =>
                                            params.userID > 0
                                                ? null
                                                : validateLocation()
                                        }
                                        error={
                                            locationErr.length > 0
                                                ? true
                                                : false
                                        }
                                        helperText={
                                            locationErr.length > 0
                                                ? locationErr
                                                : ''
                                        }
                                        onChange={(event) => {
                                            state.hotelName.set(
                                                event.target.value
                                            );
                                            handleDisableBtn();
                                            validateLocation();
                                        }}
                                    />
                                </Grid>
                            ) : null}
                            <Grid item lg={12} md={12} xs={12}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    multiline
                                    rows={3}
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Additional Comments/Notes"
                                    value={state.comments.get()}
                                    onChange={(event) => {
                                        state.comments.set(event.target.value);
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>

                    {/* {checkEditPermission ? (
                    <> */}
                    <Divider
                        light={false}
                        sx={{
                            mt: 2,
                            marginRight: 0,
                            mb: 2,
                            background: 'blue',
                        }}
                        flexItem
                    />
                    {/* <Stack
                    spacing={2}
                    direction="row-reverse"
                    sx={{ m: 1 }}>
                {props.loading ?
                     <CircularProgress size={20} color="inherit"/> 
                     :   
                    <Button variant="contained" onClick={handleClick} disabled={
                        Helper.isAdminUser(userInfo) ||
                            (userInfo.roles && Helper.isEventAdmin(userInfo)) ? (disableBtn === true ? true : false) : (eventInfo.readonlyOrHide === 1 ? true :
                                !checkEditPermission ? true : disableBtn)}
                    >
                        {state.addedFor.get() > 0 ? 'Update' : 'Submit'}
                    </Button>
                    }
                    {props.showCancel ? (
                        <Button
                            variant="outlined"
                            onClick={handleCancelReq}>
                            Cancel
                        </Button>
                    ) : null}
                </Stack> */}
                    <Stack spacing={2} direction="row-reverse" sx={{ m: 1 }}>
                        {props.loading.get() ? (
                            <Button
                                variant="contained"
                                disabled
                            >
                                <CircularProgress
                                    size={20}
                                    color="grey"
                                    style={{ position: 'absolute' }}
                                />
                                {(state.addedFor.get() > 0 && !props.showSaveAsDraftBtn) ? 'Update' : 'Submit'}
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                onClick={handleClick}
                                disabled={
                                    Helper.isAdminUser(userInfo) ||
                                        (userInfo.roles &&
                                            Helper.isEventAdmin(userInfo))
                                        ? disableBtn === true
                                            ? true
                                            : false
                                        : eventInfo.readonlyOrHide === 1
                                            ? true
                                            : !checkEditPermission
                                                ? true
                                                : disableBtn
                                }>
                                {(state.addedFor.get() > 0 && !props.showSaveAsDraftBtn) ? ((props && props.data && props.data.requestStatus) == 1) ? 'Update & Submit' : 'Update' : 'Submit'}
                            </Button>
                        )}
                        {props.showSaveAsDraftBtn ? (
                            <Button
                                variant="outlined"
                                onClick={handleSaveAsDraft}
                                disabled={(disableDraftBtn || saveAsDraftLoader)}
                            >
                                {
                                    saveAsDraftLoader ? <CircularProgress
                                        size={20}
                                        color="grey"
                                        style={{ position: 'absolute' }}
                                    /> : null
                                }
                                Save As Draft
                            </Button>
                        ) : null}
                        {props.showCancel ? (
                            <Button
                                variant="outlined"
                                onClick={handleCancelReq}>
                                Cancel
                            </Button>
                        ) : null}
                    </Stack>
                </Box>
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}

                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 150,
                    }}
                    open={openBackdrop}
                //onClick={handleCloseBackDrop}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <RouterPrompt key='allStarRegistration'
                    when={dirty}
                    title="Leave this page"
                    cancelText="No"
                    okText="Yes"
                    onOK={handleSaveAsDraftOnPromptConfirm}
                    onCancel={handleCancelConfirmation}
                    message="There are unsaved changes. Do you want to save it?"
                />
            </Box>
        </Box>
    );
};

export default AllStarRegistration;
